"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var info = [{
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: '8ball',
    client_id: '07-tendermint-2',
    connection_id: 'connection-18'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2668',
    connection_id: 'connection-2163'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-16',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-641',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'acrechain',
    client_id: '07-tendermint-0',
    connection_id: 'connection-0'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2316',
    connection_id: 'connection-1814'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-490',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'agoric',
    client_id: '07-tendermint-1',
    connection_id: 'connection-1'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2109',
    connection_id: 'connection-1649'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-320',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'aioz',
    client_id: '07-tendermint-2',
    connection_id: 'connection-1'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2785',
    connection_id: 'connection-2285'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-779',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'akash',
    client_id: '07-tendermint-18',
    connection_id: 'connection-11'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-0',
    connection_id: 'connection-2'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-9',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'archway',
    client_id: '07-tendermint-2',
    connection_id: 'connection-1'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2850',
    connection_id: 'connection-2362'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-1429',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'arkh',
    client_id: '07-tendermint-34',
    connection_id: 'connection-27'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2697',
    connection_id: 'connection-2235'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-12',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-648',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'assetmantle',
    client_id: '07-tendermint-0',
    connection_id: 'connection-0'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1923',
    connection_id: 'connection-1498'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-232',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'aura',
    client_id: '07-tendermint-47',
    connection_id: 'connection-33'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-3054',
    connection_id: 'connection-2551'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-10',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-11304',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'axelar',
    client_id: '07-tendermint-23',
    connection_id: 'connection-13'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1862',
    connection_id: 'connection-1453'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-3',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-208',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'bandchain',
    client_id: '07-tendermint-94',
    connection_id: 'connection-91'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1743',
    connection_id: 'connection-1345'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-83',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-148',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'beezee',
    client_id: '07-tendermint-2',
    connection_id: 'connection-0'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2154',
    connection_id: 'connection-1672'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-340',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'bitcanna',
    client_id: '07-tendermint-1',
    connection_id: 'connection-1'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1499',
    connection_id: 'connection-1167'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-51',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'bitsong',
    client_id: '07-tendermint-0',
    connection_id: 'connection-0'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1551',
    connection_id: 'connection-1216'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-73',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'bluzelle',
    client_id: '07-tendermint-0',
    connection_id: 'connection-0'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2754',
    connection_id: 'connection-2273'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-763',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'bostrom',
    client_id: '07-tendermint-5',
    connection_id: 'connection-2'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1597',
    connection_id: 'connection-1255'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-2',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-95',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'canto',
    client_id: '07-tendermint-9',
    connection_id: 'connection-9'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2481',
    connection_id: 'connection-2017'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-5',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-550',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'carbon',
    client_id: '07-tendermint-3',
    connection_id: 'connection-1'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1808',
    connection_id: 'connection-1412'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-188',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'celestia',
    client_id: '07-tendermint-10',
    connection_id: 'connection-2'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-3012',
    connection_id: 'connection-2503'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-2',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-6994',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'cerberus',
    client_id: '07-tendermint-1',
    connection_id: 'connection-1'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1875',
    connection_id: 'connection-1460'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-212',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'chain4energy',
    client_id: '07-tendermint-2',
    connection_id: 'connection-2'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-3107',
    connection_id: 'connection-2586'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-22172',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'cheqd',
    client_id: '07-tendermint-0',
    connection_id: 'connection-0'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1615',
    connection_id: 'connection-1268'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-108',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'chihuahua',
    client_id: '07-tendermint-45',
    connection_id: 'connection-25'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1666',
    connection_id: 'connection-1278'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-7',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-113',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }, {
    chain_1: {
      channel_id: 'channel-73',
      port_id: 'wasm.chihuahua1jwkag4yvhyj9fuddtkygvavya8hmdjuzmgxwg9vp3lw9twv6lrcq9mgl52'
    },
    chain_2: {
      channel_id: 'channel-11348',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'comdex',
    client_id: '07-tendermint-1',
    connection_id: 'connection-1'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1587',
    connection_id: 'connection-1243'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-87',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'composable',
    client_id: '07-tendermint-6',
    connection_id: 'connection-6'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2846',
    connection_id: 'connection-2358'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-3',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-1279',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'coreum',
    client_id: '07-tendermint-3',
    connection_id: 'connection-3'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2929',
    connection_id: 'connection-2426'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-2',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-2188',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'cosmoshub',
    client_id: '07-tendermint-259',
    connection_id: 'connection-257'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1',
    connection_id: 'connection-1'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-141',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'crescent',
    client_id: '07-tendermint-17',
    connection_id: 'connection-12'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2083',
    connection_id: 'connection-1624'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-9',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-297',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'cryptoorgchain',
    client_id: '07-tendermint-33',
    connection_id: 'connection-12'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-4',
    connection_id: 'connection-5'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-10',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-5',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'cudos',
    client_id: '07-tendermint-2084',
    connection_id: 'connection-1626'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1',
    connection_id: 'connection-1'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-298',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'decentr',
    client_id: '07-tendermint-6',
    connection_id: 'connection-1'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1798',
    connection_id: 'connection-1403'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-181',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'desmos',
    client_id: '07-tendermint-6',
    connection_id: 'connection-4'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1726',
    connection_id: 'connection-1315'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-2',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-135',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'dig',
    client_id: '07-tendermint-13',
    connection_id: 'connection-8'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1714',
    connection_id: 'connection-1304'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-128',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'doravota',
    client_id: '07-tendermint-0',
    connection_id: 'connection-1'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2959',
    connection_id: 'connection-2454'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-2694',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'dydx',
    client_id: '07-tendermint-3',
    connection_id: 'connection-7'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-3009',
    connection_id: 'connection-2500'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-3',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-6787',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'dymension',
    client_id: '07-tendermint-2',
    connection_id: 'connection-2'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-3086',
    connection_id: 'connection-2566'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-2',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-19774',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'dyson',
    client_id: '07-tendermint-2',
    connection_id: 'connection-5'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2407',
    connection_id: 'connection-1895'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-2',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-526',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'echelon',
    client_id: '07-tendermint-107',
    connection_id: 'connection-29'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2268',
    connection_id: 'connection-1760'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-11',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-403',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'emoney',
    client_id: '07-tendermint-7',
    connection_id: 'connection-2'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1447',
    connection_id: 'connection-1132'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-37',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'empowerchain',
    client_id: '07-tendermint-1',
    connection_id: 'connection-1'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2848',
    connection_id: 'connection-2360'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-1411',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'evmos',
    client_id: '07-tendermint-0',
    connection_id: 'connection-0'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1840',
    connection_id: 'connection-1440'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-204',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'fetchhub',
    client_id: '07-tendermint-10',
    connection_id: 'connection-10'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1913',
    connection_id: 'connection-1490'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-10',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-229',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'furya',
    client_id: '07-tendermint-4',
    connection_id: 'connection-3'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-3029',
    connection_id: 'connection-2515'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-3',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-8690',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'fxcore',
    client_id: '07-tendermint-23',
    connection_id: 'connection-22'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2961',
    connection_id: 'connection-2456'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-19',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-2716',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'galaxy',
    client_id: '07-tendermint-0',
    connection_id: 'connection-0'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1928',
    connection_id: 'connection-1500'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-236',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'gateway',
    client_id: '07-tendermint-8',
    connection_id: 'connection-4'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2927',
    connection_id: 'connection-2424'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-3',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-2186',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'genesisl1',
    client_id: '07-tendermint-1',
    connection_id: 'connection-1'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1983',
    connection_id: 'connection-1539'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-253',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'gitopia',
    client_id: '07-tendermint-0',
    connection_id: 'connection-0'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2787',
    connection_id: 'connection-2287'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-781',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'gravitybridge',
    client_id: '07-tendermint-13',
    connection_id: 'connection-13'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1737',
    connection_id: 'connection-1340'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-10',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-144',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'haqq',
    client_id: '07-tendermint-3',
    connection_id: 'connection-2'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2871',
    connection_id: 'connection-2388'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-2',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-1575',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'humans',
    client_id: '07-tendermint-13',
    connection_id: 'connection-4'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-3091',
    connection_id: 'connection-2570'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-4',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-20082',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'impacthub',
    client_id: '07-tendermint-12',
    connection_id: 'connection-12'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1451',
    connection_id: 'connection-1137'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-4',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-38',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'imversed',
    client_id: '07-tendermint-1',
    connection_id: 'connection-1'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2366',
    connection_id: 'connection-1866'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-517',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'injective',
    client_id: '07-tendermint-19',
    connection_id: 'connection-14'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1703',
    connection_id: 'connection-1298'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-8',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-122',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'irisnet',
    client_id: '07-tendermint-5',
    connection_id: 'connection-4'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-5',
    connection_id: 'connection-6'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-3',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-6',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'jackal',
    client_id: '07-tendermint-2',
    connection_id: 'connection-0'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2273',
    connection_id: 'connection-1762'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-412',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'juno',
    client_id: '07-tendermint-0',
    connection_id: 'connection-0'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1457',
    connection_id: 'connection-1142'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-42',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }, {
    chain_1: {
      channel_id: 'channel-47',
      port_id: 'wasm.juno1v4887y83d6g28puzvt8cl0f3cdhd3y6y9mpysnsp3k8krdm7l6jqgm0rkn'
    },
    chain_2: {
      channel_id: 'channel-169',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'kava',
    client_id: '07-tendermint-2',
    connection_id: 'connection-1'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1735',
    connection_id: 'connection-1328'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-143',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'kichain',
    client_id: '07-tendermint-4',
    connection_id: 'connection-0'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1564',
    connection_id: 'connection-1225'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-77',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }, {
    chain_1: {
      channel_id: 'channel-18',
      port_id: 'wasm.ki1hzz0s0ucrhdp6tue2lxk3c03nj6f60qy463we7lgx0wudd72ctmsd9kgha'
    },
    chain_2: {
      channel_id: 'channel-261',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'konstellation',
    client_id: '07-tendermint-1',
    connection_id: 'connection-0'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1778',
    connection_id: 'connection-1384'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-171',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'kujira',
    client_id: '07-tendermint-3',
    connection_id: 'connection-2'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2017',
    connection_id: 'connection-1559'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-3',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-259',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'kyve',
    client_id: '07-tendermint-0',
    connection_id: 'connection-0'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2757',
    connection_id: 'connection-2274'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-767',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'lambda',
    client_id: '07-tendermint-6',
    connection_id: 'connection-5'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2217',
    connection_id: 'connection-1733'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-2',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-378',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'likecoin',
    client_id: '07-tendermint-16',
    connection_id: 'connection-9'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1507',
    connection_id: 'connection-1173'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-3',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-53',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'lumenx',
    client_id: '07-tendermint-0',
    connection_id: 'connection-6'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2079',
    connection_id: 'connection-1620'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-3',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-286',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'lumnetwork',
    client_id: '07-tendermint-7',
    connection_id: 'connection-5'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1668',
    connection_id: 'connection-1280'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-3',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-115',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'mars',
    client_id: '07-tendermint-4',
    connection_id: 'connection-3'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2602',
    connection_id: 'connection-2114'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-557',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'medasdigital',
    client_id: '07-tendermint-0',
    connection_id: 'connection-0'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2372',
    connection_id: 'connection-1869'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-519',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'meme',
    client_id: '07-tendermint-0',
    connection_id: 'connection-1'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1931',
    connection_id: 'connection-1502'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-238',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'microtick',
    client_id: '07-tendermint-99',
    connection_id: 'connection-92'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1453',
    connection_id: 'connection-1139'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-16',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-39',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'migaloo',
    client_id: '07-tendermint-3',
    connection_id: 'connection-11'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2669',
    connection_id: 'connection-2171'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-5',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-642',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'neutron',
    client_id: '07-tendermint-19',
    connection_id: 'connection-18'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2823',
    connection_id: 'connection-2338'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-10',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-874',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'noble',
    client_id: '07-tendermint-0',
    connection_id: 'connection-2'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2704',
    connection_id: 'connection-2241'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-750',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'nois',
    client_id: '07-tendermint-16',
    connection_id: 'connection-10'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-3017',
    connection_id: 'connection-2507'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-37',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-8277',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }, {
    chain_1: {
      channel_id: 'channel-11319',
      port_id: 'wasm.osmo1tvzr8ur0ynjhqftxpkl4qwel8ly7erhy6cu6ks426xmzf92vk6eqfp9wcl'
    },
    chain_2: {
      channel_id: 'channel-41',
      port_id: 'wasm.nois1acyc05v6fgcdgj88nmz2t40aex9nlnptqpwp5hf8hwg7rhce9uuqgqz5wp'
    },
    ordering: 'unordered',
    version: 'nois-v7',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'nolus',
    client_id: '07-tendermint-0',
    connection_id: 'connection-0'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2791',
    connection_id: 'connection-2289'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-783',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'nomic',
    client_id: '07-tendermint-1',
    connection_id: 'connection-1'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-3010',
    connection_id: 'connection-2501'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-6897',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'nyx',
    client_id: '07-tendermint-17',
    connection_id: 'connection-8'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-3065',
    connection_id: 'connection-2555'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-8',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-15464',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'odin',
    client_id: '07-tendermint-113',
    connection_id: 'connection-9'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-3088',
    connection_id: 'connection-1551'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-3',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-258',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'omniflixhub',
    client_id: '07-tendermint-8',
    connection_id: 'connection-8'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1829',
    connection_id: 'connection-1431'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-199',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'onomy',
    client_id: '07-tendermint-0',
    connection_id: 'connection-1'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2405',
    connection_id: 'connection-1892'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-525',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'oraichain',
    client_id: '07-tendermint-49',
    connection_id: 'connection-21'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1882',
    connection_id: 'connection-1464'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-13',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-216',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1576',
    connection_id: 'connection-1231'
  },
  chain_2: {
    chain_name: 'panacea',
    client_id: '07-tendermint-6',
    connection_id: 'connection-1'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-82',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2935',
    connection_id: 'connection-2430'
  },
  chain_2: {
    chain_name: 'passage',
    client_id: '07-tendermint-1',
    connection_id: 'connection-1'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-2494',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-3',
    connection_id: 'connection-4'
  },
  chain_2: {
    chain_name: 'persistence',
    client_id: '07-tendermint-6',
    connection_id: 'connection-5'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-4',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-6',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2318',
    connection_id: 'connection-1815'
  },
  chain_2: {
    chain_name: 'planq',
    client_id: '07-tendermint-3',
    connection_id: 'connection-2'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-492',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1899',
    connection_id: 'connection-1472'
  },
  chain_2: {
    chain_name: 'provenance',
    client_id: '07-tendermint-31',
    connection_id: 'connection-9'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-222',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-7',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-3059',
    connection_id: 'connection-2554'
  },
  chain_2: {
    chain_name: 'pundix',
    client_id: '07-tendermint-1',
    connection_id: 'connection-1'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-12618',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-3070',
    connection_id: 'connection-2558'
  },
  chain_2: {
    chain_name: 'pylons',
    client_id: '07-tendermint-32',
    connection_id: 'connection-25'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-17683',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-29',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2703',
    connection_id: 'connection-2240'
  },
  chain_2: {
    chain_name: 'quasar',
    client_id: '07-tendermint-1',
    connection_id: 'connection-1'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-688',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2400',
    connection_id: 'connection-1889'
  },
  chain_2: {
    chain_name: 'quicksilver',
    client_id: '07-tendermint-6',
    connection_id: 'connection-2'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-522',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-2',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2831',
    connection_id: 'connection-2345'
  },
  chain_2: {
    chain_name: 'qwoyn',
    client_id: '07-tendermint-0',
    connection_id: 'connection-0'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-880',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2849',
    connection_id: 'connection-2361'
  },
  chain_2: {
    chain_name: 'realio',
    client_id: '07-tendermint-1',
    connection_id: 'connection-1'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-1424',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2173',
    connection_id: 'connection-1692'
  },
  chain_2: {
    chain_name: 'rebus',
    client_id: '07-tendermint-0',
    connection_id: 'connection-0'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-355',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-6',
    connection_id: 'connection-7'
  },
  chain_2: {
    chain_name: 'regen',
    client_id: '07-tendermint-1',
    connection_id: 'connection-1'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-8',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1898',
    connection_id: 'connection-1471'
  },
  chain_2: {
    chain_name: 'rizon',
    client_id: '07-tendermint-3',
    connection_id: 'connection-1'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-221',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-3098',
    connection_id: 'connection-2571'
  },
  chain_2: {
    chain_name: 'scorum',
    client_id: '07-tendermint-6',
    connection_id: 'connection-1'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-20100',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1588',
    connection_id: 'connection-1244'
  },
  chain_2: {
    chain_name: 'secretnetwork',
    client_id: '07-tendermint-2',
    connection_id: 'connection-1'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-88',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis',
      properties: 'privacy'
    }
  }, {
    chain_1: {
      channel_id: 'channel-476',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-44',
      port_id: 'wasm.secret1tqmms5awftpuhalcv5h5mg76fa0tkdz4jv9ex4'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis',
      properties: 'privacy'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2790',
    connection_id: 'connection-2288'
  },
  chain_2: {
    chain_name: 'sei',
    client_id: '07-tendermint-2',
    connection_id: 'connection-0'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-782',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2',
    connection_id: 'connection-3'
  },
  chain_2: {
    chain_name: 'sentinel',
    client_id: '07-tendermint-0',
    connection_id: 'connection-0'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-2',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2972',
    connection_id: 'connection-2468'
  },
  chain_2: {
    chain_name: 'sge',
    client_id: '07-tendermint-0',
    connection_id: 'connection-0'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-5485',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2680',
    connection_id: 'connection-2182'
  },
  chain_2: {
    chain_name: 'shareledger',
    client_id: '07-tendermint-1',
    connection_id: 'connection-5'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-647',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1741',
    connection_id: 'connection-1342'
  },
  chain_2: {
    chain_name: 'shentu',
    client_id: '07-tendermint-9',
    connection_id: 'connection-8'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-146',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-8',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1484',
    connection_id: 'connection-1159'
  },
  chain_2: {
    chain_name: 'sifchain',
    client_id: '07-tendermint-41',
    connection_id: 'connection-20'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-47',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-17',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1745',
    connection_id: 'connection-1348'
  },
  chain_2: {
    chain_name: 'sommelier',
    client_id: '07-tendermint-0',
    connection_id: 'connection-0'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-165',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-3035',
    connection_id: 'connection-2524'
  },
  chain_2: {
    chain_name: 'source',
    client_id: '07-tendermint-0',
    connection_id: 'connection-0'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-8945',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2969',
    connection_id: 'connection-2465'
  },
  chain_2: {
    chain_name: 'stafihub',
    client_id: '07-tendermint-7',
    connection_id: 'connection-6'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-5413',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-10',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1562',
    connection_id: 'connection-1223'
  },
  chain_2: {
    chain_name: 'stargaze',
    client_id: '07-tendermint-0',
    connection_id: 'connection-0'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-75',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-71',
    connection_id: 'connection-42'
  },
  chain_2: {
    chain_name: 'starname',
    client_id: '07-tendermint-9',
    connection_id: 'connection-9'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-15',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-2',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2119',
    connection_id: 'connection-1657'
  },
  chain_2: {
    chain_name: 'stride',
    client_id: '07-tendermint-1',
    connection_id: 'connection-2'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-326',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-5',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2192',
    connection_id: 'connection-1710'
  },
  chain_2: {
    chain_name: 'teritori',
    client_id: '07-tendermint-0',
    connection_id: 'connection-0'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-362',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1215',
    connection_id: 'connection-1549'
  },
  chain_2: {
    chain_name: 'terra',
    client_id: '07-tendermint-12',
    connection_id: 'connection-11'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-72',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1979',
    connection_id: 'connection-1536'
  },
  chain_2: {
    chain_name: 'terra2',
    client_id: '07-tendermint-2',
    connection_id: 'connection-3'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-251',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }, {
    chain_1: {
      channel_id: 'channel-559',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-85',
      port_id: 'wasm.terra1d90p5lacfxnqgjxjupu234lxnxyeu8fdeef4d0e0nqy3p30r7gss4myn9x'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }, {
    chain_1: {
      channel_id: 'channel-341',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-26',
      port_id: 'wasm.terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2025',
    connection_id: 'connection-1565'
  },
  chain_2: {
    chain_name: 'tgrade',
    client_id: '07-tendermint-0',
    connection_id: 'connection-0'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-263',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1805',
    connection_id: 'connection-1410'
  },
  chain_2: {
    chain_name: 'umee',
    client_id: '07-tendermint-6',
    connection_id: 'connection-0'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-184',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2229',
    connection_id: 'connection-1746'
  },
  chain_2: {
    chain_name: 'unification',
    client_id: '07-tendermint-1',
    connection_id: 'connection-1'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-382',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1705',
    connection_id: 'connection-1300'
  },
  chain_2: {
    chain_name: 'vidulum',
    client_id: '07-tendermint-0',
    connection_id: 'connection-0'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-124',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2875',
    connection_id: 'connection-2389'
  },
  chain_2: {
    chain_name: 'xpla',
    client_id: '07-tendermint-11',
    connection_id: 'connection-19'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-1634',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-9',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}];
var _default = exports["default"] = info;